import React from 'react';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { __ } from '../../Lang.js';
import VideoProgressBar from './VideoProgressBar.jsx';
import VideoBadges from './VideoBadges.jsx';
import {bcImageResize, formatDuration} from './functions.jsx';

const VideoCard = ({
  video,
  onDelete = () => {},
  isEditingGroup = false,
  isDragging = false,
}) => {
  if (!video) return null;

  // Handle both full video objects (name) and lean related video objects (title)
  const videoTitle = video.name || video.title || '';
  const videoUrl = video.permalinks?.web;
  const baseImage = video.preview_image_url;
  const imageUrl = bcImageResize(baseImage, '682x384');
  const imageSrcSet = baseImage
    ? `${bcImageResize(baseImage, '435x245')} 435w, ${bcImageResize(baseImage, '682x384')} 682w, ${bcImageResize(baseImage, '377x212')} 377w`
    : '';
  const imageSizes = `(max-width: 500px) 435px, (min-width: 1200px) 377px, 682px`;

  return (
    <div className="video-card">
      {isEditingGroup && (
        <IconButton
          className="video-delete-button"
          onClick={() => onDelete(video.id)}
          title="Remove from group"
        >
          🗑️
        </IconButton>
      )}

      <Link
        href={videoUrl}
        className={`video-card__link${isEditingGroup ? ' video-card__link--active' : ''}`}
        tabIndex={isDragging ? -1 : 0}
        style={isDragging ? { pointerEvents: 'none' } : {}}
        color="inherit"
        underline="none"
        sx={{ display: 'block' }}
          onClick={(e) => {
            if (isDragging) {
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            return true;
          }}
      >
        <div className="video-card__thumbnail-container" style={{ position: 'relative' }}>
          <img
            src={imageUrl}
            srcSet={imageSrcSet}
            sizes={imageSizes}
            alt={videoTitle}
            loading="lazy"
            decoding="async"
            fetchpriority="low"
            className="video-card__thumbnail"
          />
          {video.video_time > 0 && video.duration && (
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}>
              <VideoProgressBar video_time={video.video_time} duration={video.duration} />
            </div>
          )}
          {video.duration && (
            <div className="video-card__duration">{formatDuration(video.duration)}</div>
          )}
          <div className="play-button-overlay">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#3c3630">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
        <div className="video-card__info">
          <h3 className="video-card__title">{videoTitle}</h3>
          <VideoBadges video={video} />
        </div>
      </Link>
    </div>
  );
};

export default VideoCard;